export default __webpack_public_path__ + "static/media/DunsinaneFall.5df649cb.jpg";